module.exports = __webpack_public_path__ + "static/img/w3.99f4c97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/w3.png
// module id = cKsm
// module chunks = 0